import React, { useState, useCallback } from 'react';

import { WpButton } from '../../button';
import { WpCollapsible } from '../';

const CollapsibleDocs = () => {
  const BasicExample = () => {
    const [open, setOpen] = useState(true);

    const toggleOpen = useCallback(() => setOpen(open => !open), []);
    return (
      <>
        <h5>Basic Example</h5>
        <WpButton onClick={toggleOpen}>toggle</WpButton>
        <WpCollapsible open={open}>
          <p>This is test content for the collapsible</p>
          <p>This is test content for the collapsible</p>
          <p>This is test content for the collapsible</p>
          <p>This is test content for the collapsible</p>
          <p>This is test content for the collapsible</p>
          <p>This is test content for the collapsible</p>
          <p>This is test content for the collapsible</p>
          <p>This is test content for the collapsible</p>
          <p>This is test content for the collapsible</p>
          <p>This is test content for the collapsible</p>
          <p>This is test content for the collapsible</p>
          <p>This is test content for the collapsible</p>
          <p>This is test content for the collapsible</p>
        </WpCollapsible>
      </>
    );
  };
  return (
    <>
      <BasicExample />
    </>
  );
};

export default CollapsibleDocs;
